import React from 'react';

import RankingDetail from './RankingDetail';

const RankingSelectWinner = (props: any) => <RankingDetail {...props} view="winner" />;
export default RankingSelectWinner;
